// Context Manager exports
export {
  ContextManagerProvider,
  useContextManager,
  withContextManager,
  contextUtils,
  CONTEXT_TYPE_MAP,
  CONTEXT_TAB_OPTIONS,
  CONTEXT_ICONS,
  CONTEXT_COLORS,
  type ContextType,
  type ContextTabType,
  type ContextObject,
  type ContextManagerState,
  type ContextManagerActions,
  type ContextManagerType,
} from './ContextManager';

// Context utilities exports
export {
  validateContextType,
  validateContextId,
  validateContext,
  tabTypeToContextType,
  contextTypeToTabType,
  getContextDisplayName,
  getContextIcon,
  getContextColor,
  createContext,
  createContextFromAPI,
  filterContextsByType,
  filterContextsById,
  findContextById,
  isSameContext,
  isContextInList,
  sortContextsByType,
  sortContextsById,
  sortContextsByDate,
  formatContextForAPI,
  formatContextsForAPI,
  parseContextFromAPI,
  searchContexts,
  groupContextsByType,
  groupContextsByFacility,
  getContextStats,
  validateContextForm,
  CONTEXT_CONSTANTS,
} from './contextUtils';

// Re-export UserContext for convenience
export { UserProvider, useUser } from './UserContext';

// Re-export context data hooks
export { useContextData, useContextDataForContext, useBatchContextData } from '../hooks/useContextData';

// Re-export context data service
export { ContextDataService, formatContextDataForDisplay, isContextDataComplete } from './contextDataService';
export type { ContextData, IncidentData, AuditData, CommitteeMeetingData, GrievanceData } from './contextDataService';

// Default export
export { default as ContextManager } from './ContextManager';
